export enum CancelJobSteps {
  Details = "details",
  Result = "result",
}
